import React from 'react';
import { EventItem } from 'components/EventsCalendar/types';
import { useTranslation } from 'react-i18next';
import { BsPersonRaisedHand } from 'react-icons/bs';
import useOnOutsideClick from 'legacy/common/hooks/useOnOutsideClick';
import EventCardHeader from './components/EventCardHeader';

interface EventCardProps {
  event: EventItem;
  handleNavigateToEvent: (event: EventItem) => void;
  organization: {
    id: string;
    name: string;
    badgeImageUrl: string;
  };
}

const EventCard = ({
  event,
  handleNavigateToEvent,
  organization
}: EventCardProps) => {
  const { t, i18n } = useTranslation(['organizations']);
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);
  const dropdownRef = React.useRef(null);

  const handleReportEvent = () => {
    const subject = t('events.reportEmail.subject');
    const body = t('events.reportEmail.body', {
      eventTitle: event.title,
      eventId: event.id
    });
    const mailtoLink = `mailto:help@bouncedinc.com?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
    setIsDropdownOpen(false);
  };

  const handleGoToEvent = () => {
    handleNavigateToEvent(event);
    setIsDropdownOpen(false);
  };



  useOnOutsideClick(dropdownRef, {
    isActive: isDropdownOpen,
    onOutsideClick: () => {
      setIsDropdownOpen(false);
    }
  });

  return (
    <div className={`flex flex-col relative`} ref={dropdownRef}>
      {/* Main card with hover effect */}
      <div className="group rounded-3xl transition-all duration-300 ease-in-out hover:-translate-y-1 hover:scale-[1.01] h-full">
        <div className="flex flex-col h-full">
          <EventCardHeader
            event={event}
            isDropdownOpen={isDropdownOpen}
            setIsDropdownOpen={setIsDropdownOpen}
            handleReportEvent={handleReportEvent}
            handleGoToEvent={handleGoToEvent}
            org={organization}
          />
          <div
            className={`flex flex-col rounded-3xl md:border border-gray-200 w-full md:h-[450px] md:w-[360px] flex-1 relative cursor-pointer transition-all duration-300 ease-in-out active:scale-95 group-hover:shadow-xl md:overflow-hidden`}
            role="button"
            tabIndex={0}
            onClick={() => handleNavigateToEvent(event)}
          >
            <img
              className="w-full object-cover z-0 h-full md:h-[450px]"
              src={event.photo.url}
              alt={event.title}
            />
            <div className="absolute flex flex-col items-center py-2 px-4 justify-center top-4 right-4 z-20 bg-white opacity-80 rounded-2xl text-black">
              <p className="text-sm font-semibold">
                {new Date(event.startDate).toLocaleString(i18n.language, {
                  month: 'short'
                })}
              </p>
              <p className="text-2xl font-bold">
                {new Date(event.startDate).getDate()}
              </p>
            </div>
            {event?.totalGuests > 0 && (
              <div className="absolute bottom-2 left-[50%] translate-x-[-50%] flex flex-row items-center">
                <p className="flex flex-row items-center text-lg text-white">
                  <BsPersonRaisedHand size={16} />
                  {`${event?.totalGuests}`}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventCard;
